var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.845 19.949H6.564a.513.513 0 0 1-.513-.513V6.104a1.026 1.026 0 0 0-2.051 0V19.95A2.05 2.05 0 0 0 6.051 22h11.794a1.025 1.025 0 1 0 0-2.051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.655 5.138-2.917-2.871A.9.9 0 0 0 17.096 2H8.498a.91.91 0 0 0-.909.909v14.476a.91.91 0 0 0 .909.909h11.515a.91.91 0 0 0 .908-.909V5.781a.9.9 0 0 0-.266-.643"
  })));
};
export default SvgCopy;